"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatStreetAddress = exports.formatCandidateToAddress = exports.formatStreetAddressLines = exports.transformFormValuesToAddress = exports.transformSmartyStreetsLookupToAddress = void 0;
function transformSmartyStreetsLookupToAddress(suggestion) {
    var streetLine = suggestion.streetLine, secondary = suggestion.secondary, city = suggestion.city, state = suggestion.state, zipcode = suggestion.zipcode, entries = suggestion.entries;
    var address = {
        addressLine1: streetLine,
        addressLine2: secondary || '',
        addressLine3: '',
        city: city,
        countryCode: 'USA',
        formattedAddress: '',
        postalCode: zipcode,
        stateOrArea: state,
        entries: entries,
    };
    address.formattedAddress = formatStreetAddress(address);
    return address;
}
exports.transformSmartyStreetsLookupToAddress = transformSmartyStreetsLookupToAddress;
function transformFormValuesToAddress(formValues) {
    var displayName = formValues.displayName, addressLine1 = formValues.addressLine1, addressLine2 = formValues.addressLine2, city = formValues.city, stateOrArea = formValues.stateOrArea, postalCode = formValues.postalCode, countryCode = formValues.countryCode;
    var address = {
        displayName: displayName,
        addressLine1: addressLine1,
        addressLine2: addressLine2,
        city: city,
        formattedAddress: '',
        countryCode: countryCode,
        stateOrArea: stateOrArea,
        postalCode: postalCode,
    };
    address.formattedAddress = formatStreetAddress(address);
    return address;
}
exports.transformFormValuesToAddress = transformFormValuesToAddress;
function formatStreetAddressLines(address) {
    var addressLine1 = address.addressLine1, addressLine2 = address.addressLine2, addressLine3 = address.addressLine3;
    var streetAddress = addressLine1;
    if (addressLine2) {
        streetAddress = streetAddress + ", " + addressLine2;
    }
    if (addressLine3) {
        streetAddress = streetAddress + ", " + addressLine3;
    }
    return streetAddress;
}
exports.formatStreetAddressLines = formatStreetAddressLines;
function formatCandidateToAddress(candidate) {
    var _a = candidate.components, administrativeArea = _a.administrativeArea, dependentLocality = _a.dependentLocality, locality = _a.locality, postalCode = _a.postalCode, countryIso3 = _a.countryIso3;
    var newAddress = {
        addressLine1: candidate.address1,
        city: dependentLocality || locality,
        formattedAddress: '',
        countryCode: countryIso3,
        stateOrArea: administrativeArea,
        postalCode: postalCode,
    };
    newAddress.formattedAddress = formatStreetAddress(newAddress);
    return newAddress;
}
exports.formatCandidateToAddress = formatCandidateToAddress;
function formatStreetAddress(address) {
    var city = address.city, stateOrArea = address.stateOrArea, countryCode = address.countryCode, postalCode = address.postalCode;
    var streetAddress = formatStreetAddressLines(address);
    return streetAddress + ", " + city + ", " + stateOrArea + ", " + postalCode + ", " + countryCode;
}
exports.formatStreetAddress = formatStreetAddress;
